module.exports = "<label class=radio-label><input class=\"public-radio-btn pointer\" type=radio name=\"{{ inputName }}\" value=\"{{ myValue }}\" ng-model=model> <span class=\"radio-icon {{iconType}}\" ng-class=\"{'checked': model === myValue, 'unchecked':  model !== myValue, 'opacity-07': model !== myValue }\"></span> <span class=radio-text ng-class=\"{ 'opacity-07': model !== myValue }\" ng-transclude></span></label>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/components/radio-button/radio-button.html
 ** module id = 149
 ** module chunks = 0
 **/